document.addEventListener('alpine:init', () => {
  Alpine.data('ProductMain', () => ({
    cache: {},
    gallery: null,
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitWatchers();
    },
    InitCache() {
      let am = this;
      am.cache.$gallery = am.$el.querySelector('.product-gallery__main');
    },
    InitSelf() {
      let am = this;
    },
    InitWatchers() {
      let am = this;
      am.$el.addEventListener('gallery-ready', (e) => {
        am.gallery = Flickity.data(am.cache.$gallery);
        am.gallery.on('change', am.OnGalleryChange.bind(am));
      });
    },
    OnGalleryChange(index) {
      let am = this;
      let $currentSlide = am.cache.$gallery.querySelector('.product-gallery__image.is-selected');
      let variant = JSON.parse($currentSlide.dataset.variant);
      if (!variant) return;
      am.UpdateVariant(variant);
    },
    UpdateVariant(variant) {
      let am = this;
      // console.log(variant);
      variant.options.forEach((optionValue, optionIndex) => {
        let $select = am.$el.querySelector(`[data-variant-option-index="${optionIndex}"]`);
        if ($select.value == optionValue) return;
        $select.value = optionValue;
        $select.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
  }));
});